// App.js - WEB
import React, {PureComponent} from "react";
import {Platform,View} from "react-native";
//import {ModalContainer} from "react-router-modal";
import {connect} from "react-redux";
import store from "../../redux/store";
import {
    NavigationContainer,
    DarkTheme as NavigationDarkTheme,
} from '@react-navigation/native';
import {createDrawerNavigator} from '@react-navigation/drawer';
import {createStackNavigator} from '@react-navigation/stack';
//
import SplashSatiaScreen, {
    serviceActionAccount,
    serviceActionSetConnectionInternetHotspot,
    serviceActionSetIsConnected,
    serviceActionSetToken,
    serviceActionSetUser,
    serviceActionSetUserPassWifi,
    serviceActionSetwifiConnectionStatus,
    serviceActionSetwifiIsEnabled,
    serviceActionTokenFirebase
} from "../../screens/satia/splash/action/ActionSplashSatiaScreen";

import {enableScreens} from 'react-native-screens';
import AsyncStorage from '@react-native-community/async-storage';
import {typeExport} from "../../redux/store/type";
import {navigationRef} from "../../redux/NavigationService";
import wifi from "../../importCalss/wifi";
import {serviceActionSetConnectionType} from "../../screens/137/splash/action/ActionSplashGetAllData";
import NetInfo from "@react-native-community/netinfo" ;
import axios from "axios" ;
import {AsyngStorageClass} from "../../tools/AsyngStorageClass";
import HMLoading from "../../customviews/HMLoading";


const possiblePaths = {
    ListAccountSatiaScreen: Platform.OS === "web" ? React.lazy(() => import("../../screens/satia/listAccount/ListAccountSatiaScreen")) : require("../../screens/satia/listAccount/ListAccountSatiaScreen").default,
    MainSatiaScreen: Platform.OS === "web" ? React.lazy(() => import("../../screens/satia/main/MainSatiaScreen")) : require("../../screens/satia/main/MainSatiaScreen").default,
    MenuDrawerSatia: Platform.OS === "web" ? React.lazy(() => import("../../drawer/right/MenuDrawerSatia")) : require("../../drawer/right/MenuDrawerSatia").default,
    ListServiceSatiaScreen: Platform.OS === "web" ? React.lazy(() => import("../../screens/satia/main/listService/ListServiceSatiaScreen")) : require("../../screens/satia/main/listService/ListServiceSatiaScreen").default,
    ListGigSatiaScreen: Platform.OS === "web" ? React.lazy(() => import("../../screens/satia/main/listGigs/ListGigSatiaScreen")) : require("../../screens/satia/main/listGigs/ListGigSatiaScreen").default,
    PaySatiaScreen: Platform.OS === "web" ? React.lazy(() => import("../../screens/satia/main/pay/action/ActionPaySatiaScreen")) : require("../../screens/satia/main/pay/action/ActionPaySatiaScreen").default,
    ListMicroConsumptionSatiaScreen: Platform.OS === "web" ? React.lazy(() => import("../../screens/satia/main/internetUsage/action/ActionListMicroConsumptionSatiaScreen")) : require("../../screens/satia/main/internetUsage/action/ActionListMicroConsumptionSatiaScreen").default,
    ContactUsScreen: Platform.OS === "web" ? React.lazy(() => import("../../screens/common/contactUs/ContactUsScreen")) : require("../../screens/common/contactUs/ContactUsScreen").default,
    TestConnectionScreen: Platform.OS === "web" ? React.lazy(() => import("../../screens/satia/main/testConnection/TestConnectionScreen")) : require("../../screens/satia/main/testConnection/TestConnectionScreen").default,
    ListHistoryTelephoneLineStatusSatiaScreen: Platform.OS === "web" ? React.lazy(() => import("../../screens/satia/main/listHistoryLineStatus/action/ActionListHistoryTelephoneLineStatusSatiaScreen")) : require("../../screens/satia/main/listHistoryLineStatus/action/ActionListHistoryTelephoneLineStatusSatiaScreen").default,
    ListServiceHistorySatiaScreen: Platform.OS === "web" ? React.lazy(() => import("../../screens/satia/main/listServiceHistory/action/ActionListServiceHistorySatiaScreen")) : require("../../screens/satia/main/listServiceHistory/action/ActionListServiceHistorySatiaScreen").default,
    ListMessageSatiaScreen: Platform.OS === "web" ? React.lazy(() => import("../../screens/satia/main/listMessage/action/ActionListMessageSatiaScreen")) : require("../../screens/satia/main/listMessage/action/ActionListMessageSatiaScreen").default,
    ListOnlineChargingHistorySatiaScreen: Platform.OS === "web" ? React.lazy(() => import("../../screens/satia/main/listHistoryBuyCredit/action/ActionListOnlineChargingHistorySatiaScreen")) : require("../../screens/satia/main/listHistoryBuyCredit/action/ActionListOnlineChargingHistorySatiaScreen").default,
    ListMessageOperatorSatiaScreen: Platform.OS === "web" ? React.lazy(() => import("../../screens/satia/main/listMessageOperation/action/ActionListMessageOperatorSatiaScreen")) : require("../../screens/satia/main/listMessageOperation/action/ActionListMessageOperatorSatiaScreen").default,
    ListQuestionAndAnswerSatiaScreen: Platform.OS === "web" ? React.lazy(() => import("../../screens/satia/main/listMessageOperation/action/ActionListQuestionAndAnswerSatiaScreen")) : require("../../screens/satia/main/listMessageOperation/action/ActionListQuestionAndAnswerSatiaScreen").default,
    ChangeInformationSatiaScreen: Platform.OS === "web" ? React.lazy(() => import("../../screens/satia/main/profile/action/ActionChangeInformationSatiaScreen")) : require("../../screens/satia/main/profile/action/ActionChangeInformationSatiaScreen").default,
    ProfileSatiaScreen: Platform.OS === "web" ? React.lazy(() => import("../../screens/satia/main/profile/ProfileSatiaScreen")) : require("../../screens/satia/main/profile/ProfileSatiaScreen").default,
    UploadDocumentSatiaScreen: Platform.OS === "web" ? React.lazy(() => import("../../screens/satia/main/profile/action/ActionUploadDocumentSatiaScreen")) : require("../../screens/satia/main/profile/action/ActionUploadDocumentSatiaScreen").default,
    ShowListMicroConsumptionSatiaScreen: Platform.OS === "web" ? React.lazy(() => import("../../screens/satia/main/internetUsage/ShowListMicroConsumptionSatiaScreen")) : require("../../screens/satia/main/internetUsage/ShowListMicroConsumptionSatiaScreen").default,
    SatiaScreen: Platform.OS === "web" ? React.lazy(() => import("../../screens/common/contactUs/SatiaScreen")) : require("../../screens/common/contactUs/SatiaScreen").default,
    ChartSatiaScreen: Platform.OS === "web" ? React.lazy(() => import("../../screens/satia/main/chart/ChartSatiaScreen")) : require("../../screens/satia/main/chart/ChartSatiaScreen").default,
    ShowMap: Platform.OS === "web" ? React.lazy(() => import("../../screens/common/map/ShowMap")) : require("../../screens/common/map/ShowMap").default,
    WebViewScreen: Platform.OS === "web" ? React.lazy(() => import("../../screens/common/webview/WebViewScreen")) : require("../../screens/common/webview/WebViewScreen").default,
    ListVirtualBankSatiaScreen: Platform.OS === "web" ? React.lazy(() => import("../../screens/satia/main/virtualBank/action/ActionListVirtualBankSatiaScreen")) : require("../../screens/satia/main/virtualBank/action/ActionListVirtualBankSatiaScreen").default,
    HelpSoftwareSatiaScreen: Platform.OS === "web" ? React.lazy(() => import("../../screens/satia/main/helpSoftware/HelpSoftwareSatiaScreen")) : require("../../screens/satia/main/helpSoftware/HelpSoftwareSatiaScreen").default,
    InformationSatiaScreen: Platform.OS === "web" ? React.lazy(() => import("../../screens/satia/login/information/action/ActionInformationSatiaScreen")) : require("../../screens/satia/login/information/action/ActionInformationSatiaScreen").default,
    IntroduceFriendsSatiaScreen: Platform.OS === "web" ? React.lazy(() => import("../../screens/satia/main/introduceFriends/IntroduceFriendsSatiaScreen")) : require("../../screens/satia/main/introduceFriends/IntroduceFriendsSatiaScreen").default,
    IntroduceFriendsChildSatiaScreen: Platform.OS === "web" ? React.lazy(() => import("../../screens/satia/main/introduceFriends/IntroduceFriendsChildSatiaScreen")) : require("../../screens/satia/main/introduceFriends/IntroduceFriendsChildSatiaScreen").default,
    FactorServiceHistorySatiaScreen: Platform.OS === "web" ? React.lazy(() => import("../../screens/satia/main/listServiceHistory/FactorServiceHistorySatiaScreen")) : require("../../screens/satia/main/listServiceHistory/FactorServiceHistorySatiaScreen").default,
    LoginEnterPhoneCodeSatiaScreen: Platform.OS === "web" ? React.lazy(() => import("../../screens/satia/login/enterMobile/action/ActionLoginEnterPhoneCodeSatiaScreen")) : require("../../screens/satia/login/enterMobile/action/ActionLoginEnterPhoneCodeSatiaScreen").default,
    TasksOperationSatiaScreen: Platform.OS === "web" ? React.lazy(() => import("../../screens/satia/main/operation/TasksOperationSatiaScreen")) : require("../../screens/satia/main/operation/TasksOperationSatiaScreen").default,
    AddTaskOperationSatiaScreen: Platform.OS === "web" ? React.lazy(() => import("../../screens/satia/main/operation/action/ActionAddTaskOperationSatiaScreen")) : require("../../screens/satia/main/operation/action/ActionAddTaskOperationSatiaScreen").default,
    ListTaskOperationSatiaScreen: Platform.OS === "web" ? React.lazy(() => import("../../screens/satia/main/operation/action/ActionListTaskOperationSatiaScreen")) : require("../../screens/satia/main/operation/action/ActionListTaskOperationSatiaScreen").default,
    DetailsTaskOperationSatiaScreen: Platform.OS === "web" ? React.lazy(() => import("../../screens/satia/main/operation/action/ActionDetailsTaskOperationSatiaScreen")) : require("../../screens/satia/main/operation/action/ActionDetailsTaskOperationSatiaScreen").default,
    LoginEnterUsernameSatiaScreen: Platform.OS === "web" ? React.lazy(() => import("../../screens/satia/login/enterUsername/action/ActionLoginEnterUsernameSatiaScreen")) : require("../../screens/satia/login/enterUsername/action/ActionLoginEnterUsernameSatiaScreen").default,
    ListReportTaskOperationSatiaScreen: Platform.OS === "web" ? React.lazy(() => import("../../screens/satia/main/operation/action/ActionListReportTaskOperationSatiaScreen")) : require("../../screens/satia/main/operation/action/ActionListReportTaskOperationSatiaScreen").default,
    MediaRecorderCapture: Platform.OS === "web" ? React.lazy(() => import("../../customviews/record/video/MediaRecorderCapture")) : require("../../customviews/record/video/MediaRecorderCapture").default,
    HotSpotScreen: Platform.OS === "web" ? React.lazy(() => import("../../screens/common/hotspot/HotSpotScreen")) : require("../../screens/common/hotspot/HotSpotScreen").default,
    EnterCodeSatiaScreen: Platform.OS === "web" ? React.lazy(() => import("../../screens/satia/login/enterCode/action/ActionEnterCodeSatiaScreen")) : require("../../screens/satia/login/enterCode/action/ActionEnterCodeSatiaScreen").default,
}


const ListAccountSatiaScreen = getNameComponent("ListAccountSatiaScreen");
const MainSatiaScreen = getNameComponent("MainSatiaScreen");
const MenuDrawerSatia = getNameComponent("MenuDrawerSatia");
const ListServiceSatiaScreen = getNameComponent("ListServiceSatiaScreen");
const ListGigSatiaScreen = getNameComponent("ListGigSatiaScreen");
const PaySatiaScreen = getNameComponent("PaySatiaScreen");
const ListMicroConsumptionSatiaScreen = getNameComponent("ListMicroConsumptionSatiaScreen");
const ContactUsScreen = getNameComponent("ContactUsScreen");
const TestConnectionScreen = getNameComponent("TestConnectionScreen");
const ListHistoryTelephoneLineStatusSatiaScreen = getNameComponent("ListHistoryTelephoneLineStatusSatiaScreen");
const ListServiceHistorySatiaScreen = getNameComponent("ListServiceHistorySatiaScreen");
const ListMessageSatiaScreen = getNameComponent("ListMessageSatiaScreen");
const ListOnlineChargingHistorySatiaScreen = getNameComponent("ListOnlineChargingHistorySatiaScreen");
const ListMessageOperatorSatiaScreen = getNameComponent("ListMessageOperatorSatiaScreen");
const ListQuestionAndAnswerSatiaScreen = getNameComponent("ListQuestionAndAnswerSatiaScreen");
const ChangeInformationSatiaScreen = getNameComponent("ChangeInformationSatiaScreen");
const ProfileSatiaScreen = getNameComponent("ProfileSatiaScreen");
const UploadDocumentSatiaScreen = getNameComponent("UploadDocumentSatiaScreen");
const ShowListMicroConsumptionSatiaScreen = getNameComponent("ListMicroConsumptionSatiaScreen");
const SatiaScreen = getNameComponent("SatiaScreen");
const ChartSatiaScreen = getNameComponent("ChartSatiaScreen");
const ShowMap = getNameComponent("ShowMap");
const WebViewScreen = getNameComponent("WebViewScreen");
const ListVirtualBankSatiaScreen = getNameComponent("ListVirtualBankSatiaScreen");
const HelpSoftwareSatiaScreen = getNameComponent("HelpSoftwareSatiaScreen");
const InformationSatiaScreen = getNameComponent("InformationSatiaScreen");
const IntroduceFriendsSatiaScreen = getNameComponent("IntroduceFriendsSatiaScreen");
const IntroduceFriendsChildSatiaScreen = getNameComponent("IntroduceFriendsChildSatiaScreen");
const FactorServiceHistorySatiaScreen = getNameComponent("FactorServiceHistorySatiaScreen");
const LoginEnterPhoneCodeSatiaScreen = getNameComponent("LoginEnterPhoneCodeSatiaScreen");
const TasksOperationSatiaScreen = getNameComponent("TasksOperationSatiaScreen");
const AddTaskOperationSatiaScreen = getNameComponent("AddTaskOperationSatiaScreen");
const ListTaskOperationSatiaScreen = getNameComponent("ListTaskOperationSatiaScreen");
const DetailsTaskOperationSatiaScreen = getNameComponent("DetailsTaskOperationSatiaScreen");
const LoginEnterUsernameSatiaScreen = getNameComponent("LoginEnterUsernameSatiaScreen");
const ListReportTaskOperationSatiaScreen = getNameComponent("ListReportTaskOperationSatiaScreen");
const MediaRecorderCapture = getNameComponent("MediaRecorderCapture");
const HotSpotScreen = getNameComponent("HotSpotScreen");
const EnterCodeSatiaScreen = getNameComponent("EnterCodeSatiaScreen");


//import ListAccountSatiaScreen from "../../screens/satia/listAccount/ListAccountSatiaScreen";
//import MainSatiaScreen from "../../screens/satia/main/MainSatiaScreen";
//import MenuDrawerSatia from "../../drawer/right/MenuDrawerSatia";
//import ListServiceSatiaScreen from "../../screens/satia/main/listService/ListServiceSatiaScreen";
//import ListGigSatiaScreen from "../../screens/satia/main/listGigs/ListGigSatiaScreen";
//import PaySatiaScreen from "../../screens/satia/main/pay/action/ActionPaySatiaScreen";
//import ListMicroConsumptionSatiaScreen from "../../screens/satia/main/internetUsage/action/ActionListMicroConsumptionSatiaScreen";
//import ContactUsScreen from "../../screens/common/contactUs/ContactUsScreen";
//import TestConnectionScreen from "../../screens/satia/main/testConnection/TestConnectionScreen";
//import ListHistoryTelephoneLineStatusSatiaScreen from "../../screens/satia/main/listHistoryLineStatus/action/ActionListHistoryTelephoneLineStatusSatiaScreen";
//import ListServiceHistorySatiaScreen from "../../screens/satia/main/listServiceHistory/action/ActionListServiceHistorySatiaScreen";
//import ListMessageSatiaScreen from "../../screens/satia/main/listMessage/action/ActionListMessageSatiaScreen";
//import ListOnlineChargingHistorySatiaScreen from "../../screens/satia/main/listHistoryBuyCredit/action/ActionListOnlineChargingHistorySatiaScreen";
//import ListMessageOperatorSatiaScreen from "../../screens/satia/main/listMessageOperation/action/ActionListMessageOperatorSatiaScreen";
//import ListQuestionAndAnswerSatiaScreen from "../../screens/satia/main/listMessageOperation/action/ActionListQuestionAndAnswerSatiaScreen";
//import ChangeInformationSatiaScreen from "../../screens/satia/main/profile/action/ActionChangeInformationSatiaScreen";
//import ProfileSatiaScreen from "../../screens/satia/main/profile/ProfileSatiaScreen";
//import UploadDocumentSatiaScreen from "../../screens/satia/main/profile/action/ActionUploadDocumentSatiaScreen";
//import ShowListMicroConsumptionSatiaScreen from "../../screens/satia/main/internetUsage/ShowListMicroConsumptionSatiaScreen";
//import SatiaScreen from "../../screens/common/contactUs/SatiaScreen";
//import ChartSatiaScreen from "../../screens/satia/main/chart/ChartSatiaScreen";
//import ShowMap from "../../screens/common/map/ShowMap";
//import WebViewScreen from "../../screens/common/webview/WebViewScreen";
//import ListVirtualBankSatiaScreen from "../../screens/satia/main/virtualBank/action/ActionListVirtualBankSatiaScreen";
//import HelpSoftwareSatiaScreen from "../../screens/satia/main/helpSoftware/HelpSoftwareSatiaScreen";
//import InformationSatiaScreen from "../../screens/satia/login/information/action/ActionInformationSatiaScreen";
//import IntroduceFriendsSatiaScreen from "../../screens/satia/main/introduceFriends/IntroduceFriendsSatiaScreen";
//import IntroduceFriendsChildSatiaScreen from "../../screens/satia/main/introduceFriends/IntroduceFriendsChildSatiaScreen";
//import FactorServiceHistorySatiaScreen from "../../screens/satia/main/listServiceHistory/FactorServiceHistorySatiaScreen";
//import LoginEnterPhoneCodeSatiaScreen from "../../screens/satia/login/enterMobile/action/ActionLoginEnterPhoneCodeSatiaScreen";
//import TasksOperationSatiaScreen from "../../screens/satia/main/operation/TasksOperationSatiaScreen";
//import AddTaskOperationSatiaScreen from "../../screens/satia/main/operation/action/ActionAddTaskOperationSatiaScreen";
//import ListTaskOperationSatiaScreen from "../../screens/satia/main/operation/action/ActionListTaskOperationSatiaScreen";
//import DetailsTaskOperationSatiaScreen from "../../screens/satia/main/operation/action/ActionDetailsTaskOperationSatiaScreen";
//import LoginEnterUsernameSatiaScreen from "../../screens/satia/login/enterUsername/action/ActionLoginEnterUsernameSatiaScreen";
//import ListReportTaskOperationSatiaScreen from "../../screens/satia/main/operation/action/ActionListReportTaskOperationSatiaScreen";
//import MediaRecorderCapture from "../../customviews/record/video/MediaRecorderCapture";
//import HotSpotScreen from "../../screens/common/hotspot/HotSpotScreen";

//import HomeScreen from "../../web/screens/HomeScreen";
//import SecondScreen from "../../web/screens/SecondScreen";


function getNameComponent(type) {
    return possiblePaths[type]
}

//
// const ListAccountSatiaScreen = React.lazy(() => import( "../../screens/satia/listAccount/ListAccountSatiaScreen"));
// const MainSatiaScreen = React.lazy(() => import( "../../screens/satia/main/MainSatiaScreen"));
// const MenuDrawerSatia = React.lazy(() => import( "../../drawer/right/MenuDrawerSatia"));
// const ListServiceSatiaScreen = React.lazy(() => import( "../../screens/satia/main/listService/ListServiceSatiaScreen"));
// const ListGigSatiaScreen = React.lazy(() => import( "../../screens/satia/main/listGigs/ListGigSatiaScreen"));
// const PaySatiaScreen = React.lazy(() => import( "../../screens/satia/main/pay/action/ActionPaySatiaScreen"));
// const ListMicroConsumptionSatiaScreen = React.lazy(() => import( "../../screens/satia/main/internetUsage/action/ActionListMicroConsumptionSatiaScreen"));
// const ContactUsScreen = React.lazy(() => import( "../../screens/common/contactUs/ContactUsScreen"));
// const TestConnectionScreen = React.lazy(() => import( "../../screens/satia/main/testConnection/TestConnectionScreen"));
// const ListHistoryTelephoneLineStatusSatiaScreen = React.lazy(() => import( "../../screens/satia/main/listHistoryLineStatus/action/ActionListHistoryTelephoneLineStatusSatiaScreen"));
// const ListServiceHistorySatiaScreen = React.lazy(() => import( "../../screens/satia/main/listServiceHistory/action/ActionListServiceHistorySatiaScreen"));
// const ListMessageSatiaScreen = React.lazy(() => import( "../../screens/satia/main/listMessage/action/ActionListMessageSatiaScreen"));
// const ListOnlineChargingHistorySatiaScreen = React.lazy(() => import( "../../screens/satia/main/listHistoryBuyCredit/action/ActionListOnlineChargingHistorySatiaScreen"));
// const ListMessageOperatorSatiaScreen = React.lazy(() => import( "../../screens/satia/main/listMessageOperation/action/ActionListMessageOperatorSatiaScreen"));
// const ListQuestionAndAnswerSatiaScreen = React.lazy(() => import( "../../screens/satia/main/listMessageOperation/action/ActionListQuestionAndAnswerSatiaScreen"));
// const ChangeInformationSatiaScreen = React.lazy(() => import( "../../screens/satia/main/profile/action/ActionChangeInformationSatiaScreen"));
// const ProfileSatiaScreen = React.lazy(() => import( "../../screens/satia/main/profile/ProfileSatiaScreen"));
// const UploadDocumentSatiaScreen = React.lazy(() => import( "../../screens/satia/main/profile/action/ActionUploadDocumentSatiaScreen"));
// const ShowListMicroConsumptionSatiaScreen = React.lazy(() => import( "../../screens/satia/main/internetUsage/ShowListMicroConsumptionSatiaScreen"));
// const SatiaScreen = React.lazy(() => import( "../../screens/common/contactUs/SatiaScreen"));
// const ChartSatiaScreen = React.lazy(() => import( "../../screens/satia/main/chart/ChartSatiaScreen"));
// const ShowMap = React.lazy(() => import( "../../screens/common/map/ShowMap"));
// const WebViewScreen = React.lazy(() => import( "../../screens/common/webview/WebViewScreen"));
// const ListVirtualBankSatiaScreen = React.lazy(() => import( "../../screens/satia/main/virtualBank/action/ActionListVirtualBankSatiaScreen"));
// const HelpSoftwareSatiaScreen = React.lazy(() => import( "../../screens/satia/main/helpSoftware/HelpSoftwareSatiaScreen"));
// const InformationSatiaScreen = React.lazy(() => import( "../../screens/satia/login/information/action/ActionInformationSatiaScreen"));
// const IntroduceFriendsSatiaScreen = React.lazy(() => import( "../../screens/satia/main/introduceFriends/IntroduceFriendsSatiaScreen"));
// const FactorServiceHistorySatiaScreen = React.lazy(() => import( "../../screens/satia/main/listServiceHistory/FactorServiceHistorySatiaScreen"));
//
// import HomeScreen from "../../web/screens/HomeScreen";
// import SecondScreen from "../../web/screens/SecondScreen";
// import LoginEnterPhoneCodeSatiaScreen from "../../screens/satia/login/enterMobile/action/ActionLoginEnterPhoneCodeSatiaScreen";
// import EnterCodeSatiaScreen from "../../screens/satia/login/enterCode/action/ActionEnterCodeSatiaScreen";


//import {ColorfulTabBar as TabBar} from 'react-navigation-tabbar-collection';

// const TabTest = createBottomTabNavigator();
//
// const DemoScreen = ({route}) => (
//     <View style={styles.screen}>
//         <Text>{route.name}</Text>
//     </View>
// );
// const styles = StyleSheet.create({
//     screen: {
//         width: '100%',
//         height: '100%',
//         flex: 6,
//         justifyContent: 'center',
//         alignItems: 'center',
//     },
// });
enableScreens();

const theme = {
    ...NavigationDarkTheme,
    // ...PaperDarkTheme,
    colors: {
        ...NavigationDarkTheme.colors,
        // ...PaperDarkTheme.colors,
        background: '#f0f0f0',
        text: '#ffffff'
    }
};
const HomeStack = createStackNavigator();

function HomeStackScreen() {

    return (
        <HomeStack.Navigator
            initialRouteName="TasksOperationSatiaScreen"
            screenOptions={{
                headerTitleAlign: 'center',
                headerStyle: {
                    backgroundColor: '#621FF7',
                },
                headerTintColor: '#fff',
                headerTitleStyle: {
                    fontWeight: 'bold',
                },
                headerShown: false

            }}
        >
            <HomeStack.Screen
                //    options={{ title:"ahmad",path:'ahmad' }}

                name="MainSatiaScreen" component={MainSatiaScreen}/>

            <HomeStack.Screen name="ListServiceSatiaScreen" component={ListServiceSatiaScreen}/>
            <HomeStack.Screen name="ListGigSatiaScreen" component={ListGigSatiaScreen}/>
            <HomeStack.Screen name="PaySatiaScreen" component={PaySatiaScreen}/>
            <HomeStack.Screen name="ListMicroConsumptionSatiaScreen" component={ListMicroConsumptionSatiaScreen}/>
            <HomeStack.Screen name="ContactUsScreen" component={ContactUsScreen}/>
            <HomeStack.Screen name="TestConnectionScreen" component={TestConnectionScreen}/>
            <HomeStack.Screen name="ListHistoryTelephoneLineStatusSatiaScreen"
                              component={ListHistoryTelephoneLineStatusSatiaScreen}/>
            <HomeStack.Screen name="ListServiceHistorySatiaScreen" component={ListServiceHistorySatiaScreen}/>
            <HomeStack.Screen name="ListMessageSatiaScreen" component={ListMessageSatiaScreen}/>
            <HomeStack.Screen name="ListOnlineChargingHistorySatiaScreen"
                              component={ListOnlineChargingHistorySatiaScreen}/>
            <HomeStack.Screen name="ListMessageOperatorSatiaScreen" component={ListMessageOperatorSatiaScreen}/>
            <HomeStack.Screen name="ListQuestionAndAnswerSatiaScreen" component={ListQuestionAndAnswerSatiaScreen}/>

            <HomeStack.Screen name="ChangeInformationSatiaScreen" component={ChangeInformationSatiaScreen}/>
            <HomeStack.Screen name="ProfileSatiaScreen" component={ProfileSatiaScreen}/>
            <HomeStack.Screen name="UploadDocumentSatiaScreen" component={UploadDocumentSatiaScreen}/>
            <HomeStack.Screen name="ListAccountSatiaScreen" component={ListAccountSatiaScreen}/>
            <HomeStack.Screen name="ShowListMicroConsumptionSatiaScreen"
                              component={ShowListMicroConsumptionSatiaScreen}/>
            <HomeStack.Screen name="SatiaScreen" component={SatiaScreen}/>
            <HomeStack.Screen name="ChartSatiaScreen" component={ChartSatiaScreen}/>
            <HomeStack.Screen name="ShowMap" component={ShowMap}/>
            <HomeStack.Screen name="WebViewScreen" component={WebViewScreen}/>
            <HomeStack.Screen name="ListVirtualBankSatiaScreen" component={ListVirtualBankSatiaScreen}/>
            <HomeStack.Screen name="HelpSoftwareSatiaScreen" component={HelpSoftwareSatiaScreen}/>
            <HomeStack.Screen name="InformationSatiaScreen" component={InformationSatiaScreen}/>
            <HomeStack.Screen name="IntroduceFriendsSatiaScreen" component={IntroduceFriendsSatiaScreen}/>
            <HomeStack.Screen name="IntroduceFriendsChildSatiaScreen" component={IntroduceFriendsChildSatiaScreen}/>
            <HomeStack.Screen name="FactorServiceHistorySatiaScreen" component={FactorServiceHistorySatiaScreen}/>

            {/*Operation*/}
            <HomeStack.Screen name="TasksOperationSatiaScreen" component={TasksOperationSatiaScreen}/>
            <HomeStack.Screen name="AddTaskOperationSatiaScreen" component={AddTaskOperationSatiaScreen}/>
            <HomeStack.Screen name="ListTaskOperationSatiaScreen" component={ListTaskOperationSatiaScreen}/>
            <HomeStack.Screen name="ListReportTaskOperationSatiaScreen" component={ListReportTaskOperationSatiaScreen}/>
            <HomeStack.Screen name="DetailsTaskOperationSatiaScreen" component={DetailsTaskOperationSatiaScreen}/>

            <HomeStack.Screen name="MediaRecorderCapture" component={MediaRecorderCapture}/>
            <HomeStack.Screen name="HotSpotScreen" component={HotSpotScreen}/>


            {/*           <HomeStack.Screen  name='ahmad' component={() => {
                window.location.href = 'https://google.com';
                return null;
            }}/>*/}
            {/*  <HomeStack.Screen
                name='ahmad'
                component={ Redirect }
                loc="https://meetflo.zendesk.com/hc/en-us/articles/230425728-Privacy-Policies"
            />*/}

        </HomeStack.Navigator>
    );
};

const LoginStack = createStackNavigator();

function LoginStackScreen() {

    return (
        <LoginStack.Navigator
            initialRouteName="LoginEnterUsernameSatiaScreen"
            screenOptions={{
                headerTitleAlign: 'center',
                headerStyle: {
                    backgroundColor: '#621FF7',
                },
                headerTintColor: '#fff',
                headerTitleStyle: {
                    fontWeight: 'bold',
                },
                headerShown: false
            }}

        >
            <LoginStack.Screen name="LoginEnterUsernameSatiaScreen"
                               component={LoginEnterUsernameSatiaScreen}/>
            <LoginStack.Screen name="LoginEnterPhoneCodeSatiaScreen"
                               component={LoginEnterPhoneCodeSatiaScreen}/>
            <LoginStack.Screen name="EnterCodeSatiaScreen"
                               component={EnterCodeSatiaScreen}/>
            <LoginStack.Screen name="InformationSatiaScreen"
                               component={InformationSatiaScreen}/>
            <LoginStack.Screen name="ListServiceSatiaScreen" component={ListServiceSatiaScreen}/>
            <LoginStack.Screen name="PaySatiaScreen" component={PaySatiaScreen}/>

            {/*
            <HomeStack.Screen name="SecondScreen" component={SecondScreen}/>
*/}

        </LoginStack.Navigator>
    );
};
/*const prefix = Linking.makeUrl("/");
const linking: LinkingOptions = {
    prefixes: [prefix],
    config: {
        screens: {
            HomeStack: {
                path: "stack",
                initialRouteName: "Home",
                screens: {
                    Home: "home",
                    Profile: {
                        path: "user/:id/:age",
                        parse: {
                            id: id => `there, ${id}`,
                            age: Number,
                        },
                        stringify: {
                            id: id => id.replace("there, ", ""),
                        },
                    },
                },
            },
            Settings: "settings",
        },
    },
};*/
/*
const config = {
    screens: {
        Chat: 'feed/:sort',
        Profile: 'user',
    },
};
const linking = {
    prefixes: ['https://mychat.com', 'mychat://'],
    config,
};
*/

const linking = {
    prefixes: [
        'https://app.example.com'
        /* your linking prefixes */
    ],
    config: {
        screens: {
            initialRouteName: 'SplashSatiaScreen',

            SplashSatiaScreen: 'splash',
            LoginStackScreen: 'login',
            ListAccountSatiaScreen: 'accounts',
            DrawerScreen: {

                path: 'drawer',
                screens: {
                    HomeStackScreen: {

                        path: 'home',
                        /*   screens: {
                               MainSatiaScreen: 'main',

                           }*/

                    }

                }

            },
            HelpSoftwareSatiaScreen_Root: {
                path: 'help_software_app',
                // parse: {
                //     id: (id) => `user-${id}`,
                // },
                // stringify: {
                //     id: (id) => id.replace(/^user-/, ''),
                // },
            },
            InformationSatiaScreen_Root: {
                path: 'r',
                // parse: {
                //     id: (id) => `user-${id}`,
                // },
                // stringify: {
                //     id: (id) => id.replace(/^user-/, ''),
                // },
            },
            ListServiceSatiaScreen_Root: {
                path: 'ListService',
                // parse: {
                //     id: (id) => `user-${id}`,
                // },
                // stringify: {
                //     id: (id) => id.replace(/^user-/, ''),
                // },
            },
            PaySatiaScreen_Root: {
                path: 'Pay',
                // parse: {
                //     id: (id) => `user-${id}`,
                // },
                // stringify: {
                //     id: (id) => id.replace(/^user-/, ''),
                // },
            },
            FactorServiceHistorySatiaScreen_Root: {
                path: 'print',
                // parse: {
                //     id: (id) => `user-${id}`,
                // },
                // stringify: {
                //     id: (id) => id.replace(/^user-/, ''),
                // },
            },
            /*

               DrawerScreen: {
                   path: 'drawer',
                   screens: {
                       HomeStackScreen: {
                           path: 'home',
                           screens: {

                               MainSatiaScreen: 'main',

                               ListServiceSatiaScreen:'services',


                               ListGigSatiaScreen: 'gigs',


                               PaySatiaScreen:  'pay',

                               ListMicroConsumptionSatiaScreen:  'internetUsage',

                               ContactUsScreen: 'contactUs',

                               TestConnectionScreen:  'testConnection',

                               ListHistoryTelephoneLineStatusSatiaScreen: 'lineStatus',
                               ListServiceHistorySatiaScreen:  'serviceHistory',
                               ListMessageSatiaScreen:'messages',
                               ListOnlineChargingHistorySatiaScreen:'chargingHistory',
                               ListMessageOperatorSatiaScreen:  'tickets',
                               ListQuestionAndAnswerSatiaScreen:'questions',
                               ChangeInformationSatiaScreen: 'changeInformation',
                               ProfileSatiaScreen: 'profile',
                               UploadDocumentSatiaScreen:  'upload',
                               ListAccountSatiaScreen:'accounts',
                               ShowListMicroConsumptionSatiaScreen:  'detailsInternetUsage',

                               SatiaScreen:  'satia',

                               ChartSatiaScreen: 'chart',
                               ShowMap:  'map',
                               WebViewScreen: 'web',


                               /!*



               <HomeStack.Screen name="WebViewScreen" component={WebViewScreen}/>
               *!/
                           }
                       },
                   }
               },*/

        }

    },

    // getStateFromPath: (path, options) => {
    //     // Return a state object here
    //     // You can also reuse the default logic by importing `getStateFromPath` from `@react-navigation/native`
    // },
    // getPathFromState(state, config) {
    //
    //     // Return a path string here
    //     // You can also reuse the default logic by importing `getPathFromState` from `@react-navigation/native`
    // },
};

const Drawer = createDrawerNavigator();
const DrawerScreen = () => (
    <Drawer.Navigator
        initialRouteName="HomeStackScreen"
        screenOptions={{

            headerShown: false
        }}

        drawerContent={props => <MenuDrawerSatia {...props}

        />}>


        {/*<Drawer.Screen name="MainSatiaScreen" component={MainSatiaScreen}/>*/}
        <Drawer.Screen name="HomeStackScreen" component={HomeStackScreen}/>


        {/*    <Drawer.Screen name="HomeDrawer" component={HomeScreen}/>
        <Drawer.Screen name="SupportScreen" component={SecondScreen}/>*/}
        {/*<Drawer.Screen name="UserScreen" component={UserScreen}/>*/}
        {/*<Drawer.Screen name="HomeScreen" component={HomeScreen}/>*/}
    </Drawer.Navigator>
);
const RootStack = createStackNavigator();

/*function TabTestNavi() {
    return (
        <TabTest.Navigator
            initialRouteName="Home"
            screenOptions={{headerShown: false}}
            tabBar={(props) =>
                <TabBar
                    {...props}
                    openIcon={({color, size}) => <HMIcon type="AntDesign" name="appstore-o" size={size}
                                                         color={color}/>}
                    closeIcon={({color, size}) => <HMIcon type="AntDesign" name="close" size={size} color={color}/>}
                />
            }
        >
            <TabTest.Screen
                name="Home"
                component={DemoScreen}
                options={{
                    title: 'Home',
                    icon: ({focused, color, size}) => <HMIcon type="AntDesign" name="home" size={size} color={color}/>,
                    color: 'primary',
                }}
            />
            <TabTest.Screen
                name="News"
                component={DemoScreen}
                options={{
                    title: 'News',
                    icon: ({focused, color, size}) => <HMIcon type="AntDesign" name="sharealt" size={size}
                                                              color={color}/>,
                    color: 'info',
                }}
            />
            <TabTest.Screen
                name="Chat"
                component={DemoScreen}
                options={{
                    title: 'Chat',
                    icon: ({focused, color, size}) => <HMIcon type="AntDesign" name="API" size={size} color={color}/>,
                    color: 'warning',
                }}
            />
            <TabTest.Screen
                name="Likes"
                component={DemoScreen}
                options={{
                    title: 'Likes',
                    icon: ({focused, color, size}) => <HMIcon type="AntDesign" name="hearto" size={size}
                                                              color={color}/>,
                    color: 'danger',
                }}
            />
            <TabTest.Screen
                name="Settings"
                component={DemoScreen}
                options={{
                    title: 'Settings',
                    icon: ({focused, color, size}) => <HMIcon type="AntDesign" name="setting" size={size}
                                                              color={color}/>,
                    color: 'success',
                }}
            />
        </TabTest.Navigator>
    );
}*/

// function Home() {
//     return (
//         <Tab.Navigator>
//
//             <Tab.Screen name="Profile" component={HomeScreen}/>
//             <Tab.Screen name="Feed" component={SecondScreen}/>
//         </Tab.Navigator>
//     );
// }

//const SplashStack = createStackNavigator();
//const Tab = createBottomTabNavigator();
let token = null;

/*const storage = Platform.select({
    web: () => require("localforage"),
    android: () => require("@react-native-community/async-storage").default,
    ios: () => require("@react-native-community/async-storage").default
})();*/
class RouterOperationSatia extends PureComponent {
    async componentWillMount() {
        console.log("this.props", this.props);
        token = await AsyngStorageClass.checkToken();
        store.dispatch(serviceActionSetToken(token));
        if (token) {
            let user = await AsyngStorageClass.getASyng(typeExport._USER);
            store.dispatch(serviceActionSetUser(user))

            let account = await AsyngStorageClass.getASyng("Account");
            store.dispatch(serviceActionAccount(account, 0));
        }


        let token_fb = await AsyncStorage.getItem('fcmToken');

        store.dispatch(serviceActionTokenFirebase(token_fb));


        // store.dispatch(serviceActionSetTypeLogin(typeExport._TypeLogin, t)


    }

    componentWillReceiveProps(props) {

    }

    async componentDidMount() {

        if (Platform.OS === "android") {
            let storage = await AsyngStorageClass.getASyng(typeExport._UserPassWifi);
            store.dispatch(serviceActionSetUserPassWifi(storage))
        }

        let Conn = false;

        const dispatchConnected = state => {
            let isConnected = state.isConnected
            // this.props.setIsConnected(isConnected);
            store.dispatch(serviceActionSetIsConnected(isConnected))
            store.dispatch(serviceActionSetConnectionType(state))

            if (Platform.OS === "android")
                this.checkSatusWifi()
            Conn = isConnected;

        }


        NetInfo.addEventListener(dispatchConnected);

    }

    checkSatusWifi() {

        wifi.isEnabled((isEnabled) => {
            store.dispatch(serviceActionSetwifiIsEnabled(isEnabled))


            console.log("**wifi service enabled");
            wifi.connectionStatus((isConnected) => {

                store.dispatch(serviceActionSetwifiConnectionStatus(isConnected))

                axios(
                    {
                        //    url: `http://h.1547.ir/login?username=091895610009&password=863265`,
                        //  url: `http://h.1547.ir/login?username=09189648119&password=13981398`,
                        url: `https://google.com`,
                        method: "GET",
                        timeout: 3000,
                        headers: {
                            'Content-Type': 'text/html',
                        },
                    })
                    .then(async response => {
                        console.log("response", response);
                        let data = response.data;

                        store.dispatch(serviceActionSetConnectionInternetHotspot((response && response.status === 200)))
                    })
                    .catch((e) => {
                        store.dispatch(serviceActionSetConnectionInternetHotspot(false))
                        this.setState({
                            isConnectionGoogle: false,
                            // wifiConnectionStatus: true,

                        })
                        console.log("errorrequestLogin", e);
                    })

            });

        });

    }

    render() {
        return (


            <View style={[{position: 'absolute', top: 0, bottom: 0, right: 0, left: 0}]}>
                <React.Suspense fallback={<HMLoading/>}>

                    <NavigationContainer ref={navigationRef} theme={theme} linking={linking}>
                        {/*
                        <HomeStackScreen/>
*/}
                        <RootStack.Navigator headerMode="none">

                            {/*   <RootStack.Screen
                                name="Drawer"
                                component={DrawerScreen}
                                options={{
                                    animationEnabled: false
                                }}
                            />
*/}
                            {
                                //  !this.props.resultsSatia ||  !this.props.results?

                                (
                                    !this.props.token ?
                                        <RootStack.Screen
                                            //options={{headerShown: false}}
                                            name="LoginStackScreen"
                                            component={LoginStackScreen}/>
                                        :

                                        !this.props.results ?

                                            <RootStack.Screen name="SplashSatiaScreen" component={SplashSatiaScreen}/>
                                            :
                                            <RootStack.Screen options={{headerShown: false}} name="DrawerScreen"
                                                              component={DrawerScreen}/>
                                )
                            }
                            <RootStack.Screen name="HelpSoftwareSatiaScreen_Root" component={HelpSoftwareSatiaScreen}/>
                            <RootStack.Screen name="InformationSatiaScreen_Root" component={InformationSatiaScreen}/>
                            <RootStack.Screen name="ListServiceSatiaScreen_Root" component={ListServiceSatiaScreen}/>
                            <RootStack.Screen name="PaySatiaScreen_Root" component={PaySatiaScreen}/>
                            <RootStack.Screen name="FactorServiceHistorySatiaScreen_Root"
                                              component={FactorServiceHistorySatiaScreen}/>


                        </RootStack.Navigator>

                    </NavigationContainer>
                </React.Suspense>
            </View>

        );
    }
}

const mapStateToProps = state => ({
    token: state.reducerSplashSatiaScreen.token,
    resultsSatia: state.reducerSplashSatiaScreen.resultsSatia,
    results: state.reducerSplashSatiaScreen.results,
    user: state.reducerSplashSatiaScreen.user,
    Account: state.reducerSplashSatiaScreen.Account,

});

export default connect(
    mapStateToProps,
    {}
)(RouterOperationSatia);
